import { useFetchInvitationsQuery, useFetchInviteByIdQuery, useInvitesModalStateQuery } from '../invitesApi';
import { useIsMutationPending } from '../../../utils/rtkq/useMutationPending';

export const useInvitations = (params = {}) => {
  return useFetchInvitationsQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      invitations: data ?? [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useInviteById = (id) => {
  return useFetchInviteByIdQuery({ id }, {
    skip: !id,
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      invite: data ?? null,
      isLoading,
      isError,
      error,
    }),
  });
};

export const useInvitesModalState = () => {
  return useInvitesModalStateQuery(undefined, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      modalState: data,
      isLoading,
      isError,
      error,
    }),
  });
};

// Derived read-only hooks (hooks-only pattern replacing selectors.js)
export const useIsInvitesModalOpen = () => {
  const { modalState } = useInvitesModalState();
  return !!modalState?.isInviteModalOpen;
};

export const useInvitesModalProps = () => {
  const { modalState } = useInvitesModalState();
  return modalState?.modalProps || {};
};

export const useInvitesStatus = () => {
  const { modalState } = useInvitesModalState();
  return modalState?.status || 'idle';
};

export const useInvitesSendStatus = () => {
  const { modalState } = useInvitesModalState();
  return modalState?.sendStatus || 'idle';
};

export const useInvitesCheckStatus = () => {
  const { modalState } = useInvitesModalState();
  return modalState?.checkStatus || 'idle';
};

export const useRedeemInvitation = () => {
  const { modalState } = useInvitesModalState();
  return modalState?.redeemInvitation || {};
};

export const useGiftCodeError = () => {
  const { modalState } = useInvitesModalState();
  return modalState?.giftCodeError || null;
};

export const usePendingGiftCode = () => {
  const { modalState } = useInvitesModalState();
  return modalState?.pendingGiftCode || null;
};

export const useIsSendingInvitations = () => {
  return useIsMutationPending('sendInvitations');
};
